/**
 * Utility functions for user type colors and configurations
 */

/**
 * Get the color associated with a user type
 * @param {string} userType - The user type (e.g., 'PET_GUARDIAN', 'VETERINARIAN')
 * @returns {string} The hex color code for the user type
 */
export const getUserTypeColor = (userType) => {
  const userTypeConfig = {
    'PET_GUARDIAN': '#8548A8', // Purple
    'VETERINARIAN': '#00D4B3', // Cyan
    'SERVICE_PROVIDER': '#D65745', // Orange
    'CLINIC_MODERATOR': '#2A8AD2', // Blue
    'FIRM': '#1B3A6B', // Navy Blue
  };
  return userTypeConfig[userType] || '#8548A8'; // Default to purple
};

/**
 * Convert hex color to RGB values for CSS rgba()
 * @param {string} hex - The hex color code
 * @returns {string} Comma-separated RGB values (e.g., '133, 72, 168')
 */
export const hexToRgb = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
};
